import React from 'react';
import { View, Text, StyleSheet } from "react-native";

import Colors from '../../constants/colors';
import Texts from '../../constants/texts'

const DefaultFooter = (props) => {
  return (
    <View style={[styles.container]}>
      <Text style={styles.text}>{Texts.footer}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    height: 30,
    backgroundColor: Colors.footer_background,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: Colors.light,
  }
});

export default DefaultFooter;
